var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.type === 'text')?_c('li',{staticClass:"list-item",domProps:{"innerHTML":_vm._s(_vm.item.data)}}):_c('li',{staticClass:"list-item"},[_vm._v(_vm._s(_vm.item.data.data.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }